import React, { useCallback, useEffect, useState } from "react";
import NewEvaluationForm from "./form.view";
import * as GeneralServices from "../../../services/GeneralServices";
import { STEP_PRE, TYPE_ALMOND } from "../../../constants/index";

const FormContainer = () => {
  const [data, setData] = useState(null);
  const [stepSelected, setStepSelected] = useState(STEP_PRE.code);
  const [cultivo, setCultivo] = useState(TYPE_ALMOND.code);
  const [emptyTicket, setEmptyTicket] = useState(false);
  const [farms, setFarms] = useState([]);
  const [parcels, setParcels] = useState([]);
  const [sections, setSections] = useState([]);

  const handleSubmit = async (values) => {
    try {
      const filter = {
        filters: {
          farmUuid: values.farmUuid,
        },
      };
      let result = await GeneralServices.filterData(filter);
      if (result) {
        const parcels = result[0]?.parcels || [];
        const sectionsMap = new Map();

        for (const parcel of parcels) {
          for (const section of parcel.sections || []) {
            sectionsMap.set(section.uuid, section);
            for (const parcel of parcels) {
              for (const section of parcel.sections || []) {
                sectionsMap.set(section.uuid, section);
              }
            }

            const sections = Array.from(sectionsMap.values());
            const resultFormated = {
              uuid: result[0]?.uuid,
              farmName: result[0]?.name,
              crop: result[0]?.crop,
              sections: sections,
            };
            setData(resultFormated);
          }
        }
      }
    } catch (error) {
      // console.log("Error", error);
    }
  };

  const loadData = useCallback(async () => {
    const filterFarm = {
      filters: {
        crop: cultivo,
      },
    };
    const farmsBack = await GeneralServices.filterAllFinca(filterFarm);
    const parcelsBack = await GeneralServices.filterAllParcel(filterFarm);
    if (farmsBack) {
      setFarms(farmsBack);
    }
    if (parcelsBack) {
      setParcels(parcelsBack);
    }
  }, [cultivo]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const cancel = async (resetForm) => {
    setData(null);
    setEmptyTicket(false);
    setParcels(null);
    setStepSelected(STEP_PRE.code);
    setCultivo(TYPE_ALMOND.code);
    resetForm();
  };

  const handlerFilterFinca = async (value) => {
    const filter = {
      filters: {
        name: value,
        stepType: stepSelected,
        type: cultivo,
      },
    };
    const result = await GeneralServices.filterAllFinca(filter);
    return result;
  };

  const handlerOnSelectStep = async (value) => {
    setStepSelected(value);
  };

  const handlerOnSelectType = async (value) => {
    setCultivo(value);
  };

  const handlerOnEmptyTicket = async (value) => {
    setEmptyTicket(value);
  };
  return (
    <NewEvaluationForm
      data={data}
      emptyTicket={emptyTicket}
      onSubmit={handleSubmit}
      cancelAction={cancel}
      onFilterFinca={handlerFilterFinca}
      onSelectStep={handlerOnSelectStep}
      onSelectType={handlerOnSelectType}
      onEmptyTicket={handlerOnEmptyTicket}
      farms={farms}
      parcels={parcels}
      setSections={setSections}
      setData={setData}
    />
  );
};

FormContainer.propTypes = {};

export default FormContainer;
